/**
 * @generated SignedSource<<1a1e459c95b09c9024251f5aea1c47d9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespTopYMAL_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSimilarItemCarousel_baseItem">;
  readonly " $fragmentType": "PdpRespTopYMAL_item";
};
export type PdpRespTopYMAL_item$key = {
  readonly " $data"?: PdpRespTopYMAL_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespTopYMAL_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespTopYMAL_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemCarousel_baseItem"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "26fbd60a4bc736e26abe3c6ebd0c4723";

export default node;
